
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { DeviceListApi } from "./api";
import DeviceListGrid from "./DeviceListGrid";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

interface deviceListWidgetProps {
  id: string;
  header: string;
}

const DeviceListGridWidget = (props: deviceListWidgetProps) => {
  const [deviceList, updatedeviceList] = useState(null);
  const [deviceListLoading, updateLoadingDeviceList] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    if (globalParams.mainMachineSerialNo != null) {
      updateLoadingDeviceList(true);
      getDeviceList(globalParams.mainMachineSerialNo);
    }
  }, [globalParams.mainMachineSerialNo]);

  const getDeviceList = (m) => {
    let params: any = { machineSerial: m };
    DeviceListApi.getMachineDeviceList(params)
      .then((response: any) => {
       // console.log(response);
        updatedeviceList(response);
        updateLoadingDeviceList(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingDeviceList(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  if (deviceListLoading) {
    return <Spinner text="device list" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return <DeviceListGrid data={deviceList} />;
};

export default DeviceListGridWidget;
